<template>
  <div class="flex flex-col py-2 px-2">
    <strong class="pb-4">基本信息</strong>
    <div class="finance-wallet-info mb-4">
      <div class="wallet-info-item">
        <label>开户名称</label>
        <span>{{ isNull(data?.airbillCompanyLianInfo?.name) ? '--' : data?.airbillCompanyLianInfo?.name }}</span>
      </div>
      <div v-if="!isNull(data?.airbillCompanyLianInfo?.lianNo)" class="wallet-info-item">
        <label>账户编号</label>
        <span>{{ data?.airbillCompanyLianInfo?.lianNo }}</span>
      </div>
      <div v-if="!isNull(data?.airbillCompanyLianInfo?.settleServiceRate)" class="wallet-info-item">
        <label>通道费率：</label>
        <span>{{ data?.airbillCompanyLianInfo?.settleServiceRate }}%</span>
      </div>
      <div class="wallet-info-item">
        <label>通道状态</label>
        <span>
          <el-tag type="success">已启用</el-tag>
        </span>
      </div>
      <div class="wallet-info-item">
        <label>账户状态</label>
        <span>
          <el-tag type="success">已启用</el-tag>
        </span>
      </div>
      <div class="wallet-info-item">
        <label>业务场景(公域收款)</label>
        <el-tag type="success">
          已开启
        </el-tag>
      </div>
    </div>

    <strong class="pb-4">资产信息</strong>
    <!-- 待结算金额 -->
    <div class="finance-wallet-gray">
      <div class="flex flex-col">
        <label>
          <span>待结算金额(元)</span>
          <!-- <span class="orange">冻结中，D+1可用</span> -->
        </label>
        <span>{{ !isNull(data?.airbillCompanyLianInfo?.frozenBalance) ? data?.airbillCompanyLianInfo?.frozenBalance : '--' }}</span>
      </div>

      <div v-if="data?.airbillCompanyLianInfo?.frozenBalance && Number(data?.airbillCompanyLianInfo?.frozenBalance) > 0">
        <el-button
          type="primary"
          size="small"
          @click="handleClickPage('EntryRecords')"
        >
          去解冻
        </el-button>
      </div>
    </div>
    <!-- 可用金额 -->
    <div class="finance-wallet-gray">
      <div class="flex flex-col">
        <label>
          <span>可用金额（元）</span>
          <span v-if="!isNull(data?.airbillCompanyLianInfo?.payingBalance)" class="orange">提现中：{{ data?.airbillCompanyLianInfo?.payingBalance }}</span>
        </label>
        <span>{{ !isNull(data?.airbillCompanyLianInfo?.availableBalance) ? data?.airbillCompanyLianInfo?.availableBalance : '--' }}</span>
      </div>
      <div v-if="data?.airbillCompanyLianInfo?.availableBalance && Number(data?.airbillCompanyLianInfo?.availableBalance) > 0">
        <el-button
          v-permission="['air:product:account:bill']"
          type="primary"
          size="small"
          @click="handleClickPage('SplitPaymentAccount')"
        >
          发起分账
        </el-button>
        <el-button
          v-permission="['air:product:account:withdraw']"
          type="primary"
          size="small"
          @click="doWithdraw"
        >
          提现
        </el-button>
      </div>
    </div>
  </div>
</template>
<script setup lang='ts'>
import { isNull } from '@core/tools';
import { IFinanceWallet } from '@core/main/types';
import { inject, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

const router = useRouter();

let lock = false;

const data = inject<Ref<IFinanceWallet>>('data');

function handleClickPage(name: string) {
  try {
    router.push({ name });
  } catch (error) {
    router.push({ path: '404' });
  }
}

async function doWithdraw() {
  if (lock) return;
  lock = true;

  try {
    router.push({
      name: 'LianliantoWithdrawal',
      query: { lianId: data.value?.airbillCompanyLianInfo?.lianId },
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  setTimeout(() => {
    lock = false;
  }, 500);
}
</script>

<style lang="scss" scoped>
.finance-wallet-info {
  @apply flex flex-col bg-[#F7F9FF] text-[#262626] p-[12px] text-[14px];

  &>div {
    @apply flex flex-row justify-between items-baseline pb-2;
  }

  label {
    @apply text-[var(--color-text-desc)] basis-[150px];
  }

  span {
    @apply text-right
  }
}

.finance-wallet-gray {
  @apply flex bg-[#F7F9FF] text-[#262626] p-[12px] text-[12px] justify-between items-center mb-2;

  & > div > span {
    font-size: 18px;
    font-weight: bold;
    padding-top: 3px;
  }

  .orange {
    padding-left: 12px;
    font-size: 10px;
    color: orange;
  }
}
</style>